<template>
    <div>
        <input v-if="!carregando" type="checkbox" :checked="_aprov" @change="changeStatus" />
        <div v-else class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import api from '../services/api';
import { ClientErrorException, DEFAULT_ERROR_MESSAGE, PermissaoException, ServerErrorException, TokenInvalidoException } from '../services/exceptions';
import ViewMixin from "../views/ViewMixin.vue";
import Swal from 'sweetalert2'

export default {
    name: "AprovacaoCobranca",
    props: ["id", "aprov"],
    mixins: [ViewMixin],
    data: () => {
        return {
            carregando: false,
            _aprov: false
        };
    },
    created() {
        this._aprov = this.aprov == '1'
    },

    

    methods: {

        bloquearControles() {
            let elements = document.getElementsByTagName('input');
            for (const element of elements) {
                if (element.type === 'checkbox') {
                    element.disabled = true;
                }
            }
        },

        liberarControles() {
            let elements = document.getElementsByTagName('input');
            for (const element of elements) {
                if (element.type === 'checkbox') {
                    element.disabled = false;
                }
            }
        },

        async handleAprovadoChange(checked) {
            this._aprov = checked;

            this.carregando = true;
            this.bloquearControles();

            try {
                await api.put(`/cobrancas/aprovar/${this.id}`);

                this.liberarControles();
            } catch (e) {
                this._aprov = !checked;
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }

                this.liberarControles();
            }

            this.carregando = false;
        },

        changeStatus(e) {
            const checked = e.target.checked;
            this._aprov = checked;

            let html = `Deseja ${ checked ? "aprovar" : "desaprovar" } esta cobrança?`;

            Swal.fire({
                icon: 'question',
                html: html,
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                preConfirm: () => {
                    this.handleAprovadoChange(checked);
                }
            }).then((result) => {
                if (!result.isConfirmed) {
                    e.target.checked = !checked;
                }
            });
        },
    },
};
</script>
